import { Flex, Image, Typography, Button } from 'antd';
import { FacebookFilled, InstagramFilled } from '@ant-design/icons';

const { Title, Text } = Typography;

export default function NotFound(props) {
    const { title, subtitle, description, image } = props;


    return (
        <Flex justify="center" align="center" vertical="true">
            <Title style={{ color: "#a63827", marginBottom: "0", textAlign: "center" }} strong>
                {title}
            </Title>
            <Flex className="verifier-image-container">
                <Image preview={false} src={image} alt="Rifadito RGF GDL" />
            </Flex>
            <Text style={{ fontSize: "20px", textAlign: "center" }} strong>
                {subtitle}
            </Text>
            <Text style={{ fontSize: "20px", textAlign: "center" }} strong>
                {description}
            </Text>
            <Flex style={{ marginTop: "20px", marginBottom: "30px" }}>
                <Button
                    type="link"
                    href="https://www.facebook.com/share/1BzuzWbdrC/?mibextid=wwXIfr"
                    target="_blank"
                    className="icons-buttons"
                    style={{ backgroundColor: "#1877F2" }}
                >
                    <FacebookFilled style={{ fontSize: "24px", color: "#fff" }} />
                </Button>
                <Button
                    type="link"
                    href="https://www.instagram.com/rifasgranfamiliagdl_"
                    target="_blank"
                    className="icons-buttons"
                    style={{ backgroundColor: "#E4405F" }}
                >
                    <InstagramFilled style={{ fontSize: "24px", color: "#fff" }} />
                </Button>
            </Flex>
        </Flex>
    );
}